var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.922,
    height: 31.922,
    viewBox: "0 0 31.922 31.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_copy_6",
    "data-name": "Layer 1 copy 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_77",
    "data-name": 77
  }, /*#__PURE__*/React.createElement("path", {
    id: "backgorund",
    d: "M15.961,1.185a14.771,14.771,0,1,1-5.752,1.161,14.781,14.781,0,0,1,5.752-1.161m0-1.185A15.961,15.961,0,1,0,31.922,15.961,15.961,15.961,0,0,0,15.961,0Z",
    transform: "translate(0 0)",
    fill: "#ff8d28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49604",
    "data-name": "Path 49604",
    d: "M121.95,108.748a9.352,9.352,0,1,0,2.74,6.613A9.352,9.352,0,0,0,121.95,108.748Zm-1.96,7.265h-4v4a.652.652,0,0,1-1.3,0v-4h-4a.652.652,0,1,1,0-1.3h4v-4a.652.652,0,1,1,1.3,0v4h4a.652.652,0,0,1,0,1.3Z",
    transform: "translate(-99.377 -99.4)",
    fill: "#ff8d28"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBtn);
export default __webpack_public_path__ + "static/media/addBtn.01500ae6f14a69ae2004f81b26b44866.svg";
export { ForwardRef as ReactComponent };